import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          userInfo: val.userInfo || {},
          menus: val.menus || [],
          globalTypes: val.globalTypes || []
        };
      }
    })
  ],
  state: {
    token: "",
    head: "智慧市政 温馨家园",
    facility: JSON.parse(localStorage.szFacility || null) || null,
    type: null,
    userInfo: {},
    weatherDom: null,
    menus: [],
    globalTypes: [],
    position: []
  },
  getters: {
    type: state => state.type,
    customerId: state => state.userInfo.customerId,
    token: state => state.token,
    groupId: state => state.userInfo.groupId,
    globalTypes: state => state.globalTypes,
    // facility:(state)=>{
    //   console.log(state.facility)
    //   return JSON.parse(state.facility)
    // }
    menus: state => state.menus,
    position: state => state.position
  },
  mutations: {
    SET_HEAD(state, head) {
      state.head = head;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_FACILITY(state, facility) {
      state.facility = facility;
      facility = JSON.stringify(facility);
      localStorage.removeItem("szFacility");
      localStorage.setItem("szFacility", facility);
    },
    setType(state, type) {
      console.log(type);
      localStorage.setItem("szType", type);
      state.type = type;
    },
    SET_USERINFO: (state, userInfo) => {
      Object.assign(state.userInfo, userInfo);
    },
    SET_WEATHERDOM: (state, dom) => {
      state.weatherDom = dom;
    },
    SET_MENUS: (state, menus) => {
      // 只需要字符串就行，且这里是一层的
      state.menus = [];
      let resultS = [];
      menus.forEach(menu => {
        if (menu.code.indexOf("mobile") > -1) {
          resultS.push(menu.code);
        }
      });
      state.menus = resultS;
    },
    SET_GLOBALTYPES: (state, data) => {
      console.log(data);
      state.globalTypes = data;
    },
    SET_POSITION: (state, position) => {
      console.log(position);
      state.position = position;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js